import React, { Fragment } from 'react'
import styled from '@emotion/styled'

const StyledScanViewWidgets = styled.div(({ gridColumns }) => ({
	display: 'grid',
	gridTemplateColumns: '2fr repeat(3,  minmax(100px, 1fr))',
	gridGap: 15,
	margin: '20px 0 15px'
}))

const StyledScanViewWidgetsCompare = styled.div(({ gridColumns }) => ({
	display: 'grid',
	gridTemplateColumns: "4fr repeat(3, minmax(130px, 1fr))",
	gridGap: 20,
	margin: '30px 0 15px'
}))

const ScanViewWidget = ({ data, dataKey, render, isScanCompare, isDetailsView, scanIds }) => {
	let dataProp = data && dataKey ? data[dataKey] : data
	dataProp = isScanCompare && data ? data : dataProp
	let component = render(dataProp, data, isDetailsView, scanIds)
	return <Fragment>{component}</Fragment>
}

const ScanViewWidgets = ({ data, widgets, gridColumns, isScanCompare, isDetailsView, scanIds }) => {
	return (
		isScanCompare ? 
			<StyledScanViewWidgetsCompare gridColumns={gridColumns}>
				{widgets.map((w, index) => (
					<ScanViewWidget isDetailsView={isDetailsView} key={w.dataKey || w.key || index} {...w} data={data} isScanCompare={isScanCompare} scanIds={scanIds}/>
				))}
			</StyledScanViewWidgetsCompare>
		: 
			<StyledScanViewWidgets gridColumns={gridColumns}>
				{widgets.map((w, index) => (
					<ScanViewWidget isDetailsView={isDetailsView} key={w.dataKey || w.key || index} {...w} data={data} isScanCompare={isScanCompare}/>
				))}
			</StyledScanViewWidgets>
	)
}

export default ScanViewWidgets
